<template>
  <b-dropdown class="w-100" variant="outline-secondary" :right="right" toggle-class="filter-multi"
              menu-class="o-multiselect-menu">
    <template slot="button-content">
      {{ label }}
    </template>
    <b-dropdown-text>
      <template v-if="selectAll && hasOptions">
        <b-form-checkbox class="mb-2 font-weight-bold" :indeterminate="indeterminate" :checked="allSelected"
                         @change="toggleAll">
          {{ selectAllLabel || $t('core.select_all') }}
        </b-form-checkbox>
        <b-dropdown-divider></b-dropdown-divider>
      </template>
      <b-form-checkbox-group :checked="value" :options="options" :value-field="valueField" :text-field="textField"
                             stacked @input="onInput" @change="onChange">
      </b-form-checkbox-group>
    </b-dropdown-text>
  </b-dropdown>
</template>

<script>
  export default {
    name: 'o-multiselect',
    props: {
      // Selected values (v-model)
      value: {
        type: Array,
        default: () => []
      },
      // Option list, each either a primitive or an object using valueField/textField
      options: {
        type: Array,
        default: () => []
      },
      // Text shown on the dropdown toggle button
      label: {
        type: String,
        default: ''
      },
      valueField: {
        type: String,
        default: 'value'
      },
      textField: {
        type: String,
        default: 'text'
      },
      // When true, renders a "Select all" toggle at the top of the dropdown
      selectAll: {
        type: Boolean,
        default: false
      },
      // Optional override for the "Select all" label (defaults to core.select_all)
      selectAllLabel: {
        type: String,
        default: ''
      },
      right: {
        type: Boolean,
        default: true
      }
    },

    computed: {
      hasOptions() {
        return this.options && this.options.length > 0
      },
      optionValues() {
        return this.options.map((option) => {
          return (option && typeof option === 'object') ? option[this.valueField] : option
        })
      },
      allSelected() {
        return this.optionValues.length > 0 && this.optionValues.every((v) => this.value.includes(v))
      },
      indeterminate() {
        return this.value.length > 0 && !this.allSelected
      }
    },

    methods: {
      onInput(value) {
        this.$emit('input', value)
      },
      onChange(value) {
        this.$emit('change', value)
      },
      toggleAll(checked) {
        const next = checked ? this.optionValues.slice() : []
        this.$emit('input', next)
        this.$emit('change', next)
      }
    }
  }
</script>

<style>
  /* Keep the menu anchored under the toggle: cap its height (scroll) so a long
     option list can't grow taller than the viewport and get flipped/repositioned,
     and cap its width so long labels wrap instead of overflowing. */
  .o-multiselect-menu {
    max-height: 320px;
    overflow-y: auto;
    min-width: 240px;
    max-width: 340px;
  }

  .o-multiselect-menu .custom-control-label {
    white-space: normal;
    word-break: break-word;
  }
</style>
